import React from 'react';
import styles from '@/styles/components/question-builders/QuestionPreviewContent.module.css';
import QuestionType, {
  getQuestionTypeText,
} from '@ax2/common/model/QuestionType';

export interface QuestionPreviewContentData {
  questionText: string | null;
  questionType: QuestionType;
}

export const QuestionPreviewContent: React.FC<
  QuestionPreviewContentData
> = props => {
  return (
    <div className={styles.questionContentWrapper}>
      <div className={styles.questionContent}>
        <span className={styles.title}>Survey Question</span>
        <span className={styles.text}>
          {new DOMParser().parseFromString(
            props.questionText || '',
            'text/html'
          ).body.innerText || ''}
        </span>
      </div>
      <div className={styles.questionType}>
        <span className={styles.title}>Question Type</span>
        <span className={styles.text}>
          {props.questionType !== QuestionType.Empty
            ? getQuestionTypeText(props.questionType)
            : 'Not selected'}
        </span>
      </div>
    </div>
  );
};
